export default {
  'Please select an output format': 'Lütfen bir çıktı biçimi seçin',
}